"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    MODAL_ARIA_LABEL: ()=>MODAL_ARIA_LABEL,
    MODAL_ARIA_TITLE: ()=>MODAL_ARIA_TITLE,
    getDisplayConfig: ()=>getDisplayConfig
});
const MODAL_ARIA_LABEL = 'Travel Bot Chat Dialog Modal';
const MODAL_ARIA_TITLE = 'Travel Bot Chat Dialog';
const getDisplayConfig = (viewType, isMobile)=>{
    const displayConfig = {
        LANDING: {
            chatContainerHeight: '85%',
            dialogOverlayProps: {
                ariaDescription: MODAL_ARIA_LABEL,
                ariaTitle: MODAL_ARIA_TITLE,
                fullWidth: isMobile,
                scrimColor: 'medium',
                zIndex: 1000
            }
        },
        CHECKOUT: {
            chatContainerHeight: '85%',
            dialogOverlayProps: {
                ariaDescription: MODAL_ARIA_LABEL,
                ariaTitle: MODAL_ARIA_TITLE,
                fullWidth: isMobile
            }
        },
        DRIVE: {
            chatContainerHeight: '85%',
            dialogOverlayProps: {
                ariaDescription: MODAL_ARIA_LABEL,
                ariaTitle: MODAL_ARIA_TITLE,
                fullWidth: isMobile,
                scrimColor: 'medium',
                zIndex: 1000
            }
        },
        FLYDETAILS: {
            chatContainerHeight: '85%',
            dialogOverlayProps: {
                ariaDescription: MODAL_ARIA_LABEL,
                ariaTitle: MODAL_ARIA_TITLE,
                fullWidth: isMobile,
                scrimColor: 'medium',
                zIndex: 1000
            }
        },
        FLYLISTINGS: {
            chatContainerHeight: '85%',
            dialogOverlayProps: {
                ariaDescription: MODAL_ARIA_LABEL,
                ariaTitle: MODAL_ARIA_TITLE,
                fullWidth: isMobile,
                scrimColor: 'medium',
                zIndex: 1000
            }
        },
        ITINERARY: {
            chatContainerHeight: '90%',
            dialogOverlayProps: {
                ariaDescription: MODAL_ARIA_LABEL,
                ariaTitle: MODAL_ARIA_TITLE,
                fullWidth: isMobile,
                scrimColor: 'medium',
                zIndex: 1000
            }
        },
        PACKAGE: {
            chatContainerHeight: '85%',
            dialogOverlayProps: {
                ariaDescription: MODAL_ARIA_LABEL,
                ariaTitle: MODAL_ARIA_TITLE,
                fullWidth: isMobile
            }
        },
        PORTAL: {
            chatContainerHeight: '85%',
            dialogOverlayProps: {
                ariaDescription: 'Dialog to chat with Penny',
                ariaTitle: 'Penny Chat Bot Dialog',
                fullWidth: isMobile
            }
        },
        STAYDETAILS: {
            chatContainerHeight: '90%',
            dialogOverlayProps: {
                ariaDescription: MODAL_ARIA_LABEL,
                ariaTitle: MODAL_ARIA_TITLE,
                fullWidth: isMobile,
                scrimColor: 'medium',
                zIndex: 1000
            }
        },
        STAYLISTINGS: {
            chatContainerHeight: '90%',
            dialogOverlayProps: {
                ariaDescription: MODAL_ARIA_LABEL,
                ariaTitle: MODAL_ARIA_TITLE,
                fullWidth: isMobile,
                scrimColor: 'medium',
                zIndex: 1000
            }
        }
    };
    const config = displayConfig[viewType];
    if (!config) throw new Error(`No display configuration found for viewType: ${viewType}. Add configuration to displayConfig object in /react-components/penny-chat-bot/src/config/displayConfig.ts. `);
    return config;
};
exports.MODAL_ARIA_LABEL = __webpack_exports__.MODAL_ARIA_LABEL;
exports.MODAL_ARIA_TITLE = __webpack_exports__.MODAL_ARIA_TITLE;
exports.getDisplayConfig = __webpack_exports__.getDisplayConfig;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "MODAL_ARIA_LABEL",
    "MODAL_ARIA_TITLE",
    "getDisplayConfig"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
